import { Option } from 'src/types/form'

export const fundingQuantityOptions: Option[] = [
  {
    label: '1 tree',
    value: '1'
  },
  {
    label: '5 trees',
    value: '5'
  },
  {
    label: '10 trees',
    value: '10'
  },
  {
    label: '25 trees',
    value: '25'
  },
  {
    label: '50 trees',
    value: '50'
  },
  {
    label: 'Other amount',
    value: 'other'
  }
]
